import { render, staticRenderFns } from "./ProgramActivityReminderListFilter.vue?vue&type=template&id=90e1bb70&scoped=true"
import script from "./ProgramActivityReminderListFilter.vue?vue&type=script&lang=js"
export * from "./ProgramActivityReminderListFilter.vue?vue&type=script&lang=js"
import style0 from "./ProgramActivityReminderListFilter.vue?vue&type=style&index=0&id=90e1bb70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e1bb70",
  null
  
)

export default component.exports